import React from 'react';
import { Button, Input } from 'semantic-ui-react';

interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  value,
  onChange,
  min = 1,
  max = 99,
  disabled = false
}) => {
  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || min;
    const clampedValue = Math.max(min, Math.min(max, newValue));
    onChange(clampedValue);
  };

  const handleInputClick = () => {
    // Selecionar todo o texto quando clicar no input
    const input = document.activeElement as HTMLInputElement;
    if (input) {
      input.select();
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Button
        icon="minus"
        size="mini"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        style={{
          minWidth: '32px',
          height: '32px',
          borderRadius: '6px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          color: value <= min ? '#6c757d' : '#495057'
        }}
      />
      
      <Input
        value={value}
        onChange={handleInputChange}
        onClick={handleInputClick}
        disabled={disabled}
        style={{
          width: '60px',
          textAlign: 'center',
          fontSize: '14px',
          fontWeight: '600'
        }}
        size="mini"
      />
      
      <Button
        icon="plus"
        size="mini"
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        style={{
          minWidth: '32px',
          height: '32px',
          borderRadius: '6px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          color: value >= max ? '#6c757d' : '#495057'
        }}
      />
    </div>
  );
};

export default QuantitySelector;

